import { ShoppingCart } from 'lucide-react';
import styles from './styles/FloatingCartBtn.module.css';

export const FloatingCartButton = ({ show, onClick, itemCount }) => {
  return (
    <button className={`${styles.floatingButton} ${show ? styles.visible : ''}`} onClick={onClick}>
      <ShoppingCart size={20} />
      {itemCount > 0 && <span className={styles.badge}>{itemCount}</span>}
    </button>
  );
};
